import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NewEventIcon = styled(Link)`
    position: absolute;
    bottom: 25px;
    right: 25px;
    background-color: rgb(35, 48, 77);
    height: 50px;
    width: 50px;
    border-radius: calc(50px / 2);
    opacity: 0.9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
`

const ListContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: rgb(35, 48, 77);
`

const Wrapper = styled(Link)`
    width: 85%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin: 10px 0;

    background-color: #fff;

    // border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-decoration: none;
`

const Image = styled.div`
    width: 100%;
    padding-bottom: 60%;
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 15px 15px 0 0;
`

const DescriptionWrapper = styled.div`
    height: 75px;
    width: 85%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const Description = styled.div`
    height: 75%;
    width: 100%;
    display: flex;    
    flex-direction: column;
    justify-content: space-evenly;

    color: rgba(23, 25, 37, 1);
`

const Title = styled.span`
    font-weight: bold;
    font-size: 1.2em;
`

const Date = styled.span`
    font-size: 0.8em;
    color: rgba(130, 137, 156, 1);

    display: flex;
    align-items: center;
`

const SearchContainer = styled.div`
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: space-evenly;
`

const Icon = styled.span`
    width: 15%;
`

const SearchForm = styled.input`
    width: 70%;
    height: 70%;

    border: 0;
    outline: 0;

    border-bottom: 1.5px solid #6A4F4F;

    font-family: rajdhani;
    font-size: 1.3em;
    font-weight: bold;
`

const Shadow = styled.div`
    position: fixed;
    bottom: 40px;
    height: 100px;
    width: 100%;

    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #2C5697 100%);
    background-blend-mode: multiply;
    mix-blend-mode: multiply;
    opacity: 0.45;
`

const NoEvent = styled.div`
    margin-top: 30px;
`

export {
    NewEventIcon,

    ListContainer,
    Wrapper,
    Image,
    DescriptionWrapper,
    Description,
    Title,
    Date,

    SearchContainer,
    Icon,
    SearchForm,

    Shadow,
    NoEvent
}